<template>
  <div class="container">
    <van-sticky>
      <PublicHeader totalName="C2C" />
      <!-- 顶部 -->
      <div class="top">
        <!-- tab切换 -->
        <div class="tabs">
          <span :class="type == 1 ? 'active' : ''" @click="onSelectType(1)">{{ $t('trade').buyBtn }}</span>
          <span :class="type == 2 ? 'active' : ''" @click="onSelectType(2)">{{ $t('trade').sellBtn }}</span>
        </div>
        <div class="right">
          <svg-icon class-name="svgs" icon-class="chat" @click="$router.push({ name: 'ChatList' })" />
          <svg-icon class-name="svgs" icon-class="history" @click="$router.push({ name: 'C2cOrder' })" />
        </div>
      </div>
      <!-- 选择币种 -->
      <div class="selInfo" @click="showPopover = true">
        <img class="img" :src="require(`@/assets/img/${currency}.png`)" />
        <div class="name">{{ currency }}</div>
        <van-icon name="play" size="13" class="ric" color="var(--primary_color)" />
      </div>
    </van-sticky>
    <PopupSelect :title="$t('bill').Currency" v-model="showPopover" :selectList="currencyArr" :selectedValue="currency" :onSelect="onSelect" />
    <!-- 产品列表 -->
    <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getSalesTemplateList" :immediate-check="false">
      <div class="item" v-for="(item, index) in pList" :key="`ven${index}`">
        <div class="name"><span>{{ item.vendorName.substring(0, 1) }}</span>{{ item.vendorName }}</div>
        <div class="price"><span style="color: var(--text_color);">$</span>{{ item.price }}<span>/USDT</span></div>
        <!-- 限额 -->
        <div class="limit">{{ $t('c2c').limit }}<span>{{ item.lowAmount }} &#8209; {{ item.highAmount }} {{ item.currency
        }}</span></div>
        <!-- 可用 -->
        <div class="amount">
          <div class="left"> {{ $t('c2c').available }}<span>{{ item.usableAmount }} {{ item.currency }}</span>
          </div>
          <!-- 按钮 -->
          <div class="btn" :class="item.type == 1 ? 'greenbg' : 'redbg'" @click="toInfo(item)">{{ item.type == 1 ?
            $t('trade').buyBtn : $t('trade').sellBtn }}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import productApi from '@/api/product'
import systemApi from '@/api/system'
import PublicHeader from '@/components/publicHeader'
import PopupSelect from '@/components/popupSelect.vue'

export default {
  components: {
    PublicHeader,
    PopupSelect,
  },
  data() {
    return {
      type: 1,
      showPopover: false,
      currencyArr: [],
      currency: 'USDT',
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 10,
      },
      pList: [],
    }
  },
  mounted() {
    this.getCurrencyNetworkSetting()
    this.getSalesTemplateList()
  },
  methods: {
    //获取系统币种
    async getCurrencyNetworkSetting() {
      const res = await systemApi.getCurrencyNetworkSetting()
      this.currencyArr = res.currencyArr.split(',').map(item => ({ text: item, val: item }))
    },
    //选择类型
    async onSelectType(val) {
      this.type = val
      this.refreshList()
    },
    //选择币种
    async onSelect(action) {
      this.currency = action.text
      this.showPopover = false
      this.refreshList()
    },
    // 去买入/卖出
    toInfo(item) {
      if (item.type == 1)
        this.$router.push({ name: 'C2cBuy', query: { id: item.vendorSalesTemplateId } })
      if (item.type == 2)
        this.$router.push({ name: 'C2cSell', query: { id: item.vendorSalesTemplateId } })
    },
    //刷新获取列表
    refreshList() {
      this.pList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.getSalesTemplateList()
    },
    // 获取产品列表
    async getSalesTemplateList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.type = this.type
      this.parms.currency = this.currency
      const res = await productApi.getSalesTemplateList(this.parms)
      this.pList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.pList.length >= res.total)
        this.finished = true;
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  padding-bottom: 30px;

  .top {
    padding: 50px 15px 0 15px;
    width: 100%;
    background: var(--background_color);
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--info_color);

    .tabs {
      font-size: 14px;
      font-weight: bold;
      color: var(--ntext_color);
      display: flex;
      align-items: center;

      span {
        padding: 12px 0;
        margin-right: 20px;
      }

      .active {
        color: var(--primary_color);
        padding-bottom: 10px;
        border-bottom: 2px solid var(--primary_color);
      }
    }

    .right {
      display: flex;
      align-items: center;

      .svgs {
        width: 20px;
        height: 20px;
        color: var(--primary_color);
        margin-left: 20px;
      }
    }
  }

  .selInfo {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--info_color);
    padding: 10px 15px;
    width: 100%;
    background: var(--background_color);

    .img {
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }

    .name {
      margin: 0 5px;
      font-size: 14px;
      color: var(--primary_color);
    }

    .ric {
      transform: rotate(90deg);
    }
  }

  .item {
    padding: 15px;
    border-bottom: 1px solid var(--info_color);

    .name {
      font-size: 14px;
      font-weight: bold;
      color: var(--text_color);
      display: flex;
      align-items: center;

      span {
        background: var(--text_color);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 10px;
        font-size: 12px;
        color: var(--background_color);
        font-weight: normal;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .price {
      margin-top: 10px;
      font-size: 22px;
      font-weight: bold;
      color: var(--text_color);

      span {
        margin-left: 5px;
        font-size: 12px;
        color: var(--ntext_color);
        font-weight: normal;
      }
    }

    .limit {
      margin-top: 10px;
      font-size: 12px;
      color: var(--ntext_color);

      span {
        margin-left: 10px;
        color: var(--text_color);
      }
    }

    .amount {
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        font-size: 12px;
        color: var(--ntext_color);

        span {
          margin-left: 10px;
          color: var(--text_color);
        }
      }

      .btn {
        padding: 5px 20px;
        border-radius: 15px;
        font-size: 11px;
        font-weight: normal;
        color: #fff;
      }
    }
  }
}
</style>
